'use strict';

document.addEventListener('DOMContentLoaded', () => {
	const cardContainer = document.querySelector('.js-card-list');
	const ratingButton = document.querySelector('.js-rating-more');

	if (ratingButton) {
		ratingButton.classList.remove('hidden');
		const next_page = ratingButton.getAttribute('data-page');
		ratingButton.addEventListener('click', (e) => {
			e.preventDefault();
			let eventBtn = e.currentTarget;
			eventBtn.setAttribute('disabled', true);

			let page = e.target.getAttribute('data-page');
			let formData = new FormData();
			formData.append('action', e.target.getAttribute('data-action'));
			formData.append('per_page', e.target.getAttribute('data-per-page'));
			formData.append('post_id', e.target.getAttribute('data-id'));
			formData.append('page', e.target.getAttribute('data-page'));
			formData.append('page_type', e.target.getAttribute('data-page-type'));
			formData.append('page_start', next_page - 1);

			fetch(themeVar.url, {
				method: 'POST',
				body: formData
			})
			.then(response => response.json())
			.then(data => {
				if (data.status == 'done') {
					cardContainer.insertAdjacentHTML('beforeend', data.posts);
					eventBtn.removeAttribute('disabled');
					e.target.setAttribute('data-page', ++page);

					if (e.target.getAttribute('data-max-page') < page) {
						e.target.classList.add('hidden');
					}
				}

				if(data.status == 'fail') {
					e.target.classList.add('hidden');
					eventBtn.removeAttribute('disabled');
				}
			});
		});
	}
});
